import React from "react";
import Card from "./common/Card";
import SectionTitle from "./common/SectionTitle";

const testimonials = [
	{
		id: 1,
		name: "Sarah Johnson",
		role: "CTO, TechCorp",
		content:
			"Trivnet transformed our digital infrastructure. Their team delivered beyond our expectations.",
		rating: 5,
	},
	{
		id: 2,
		name: "Michael Chen",
		role: "Director, FinServe",
		content:
			"The mobile app they developed increased our customer engagement by 40% in just 3 months.",
		rating: 5,
	},
	{
		id: 3,
		name: "Emily Rodriguez",
		role: "CEO, HealthPlus",
		content:
			"Their cybersecurity solutions helped us achieve compliance and secure our sensitive data.",
		rating: 4,
	},
];

const Testimonials = () => {
	return (
		<section className="testimonials pb-20">
			<div className="container flex flex-col sm:flex lg:flex-row">
				<SectionTitle
					title="Client Testimonials"
					subtitle="What our clients say about us"
				/>

				<div className="testimonials-grid">
					{testimonials.map((testimonial) => (
						<Card key={testimonial.id}>
							<div className="testimonial-content">
								<p>"{testimonial.content}"</p>
								<div className="rating">
									{[...Array(testimonial.rating)].map((_, i) => (
										<i key={i} className="fas fa-star"></i>
									))}
								</div>
							</div>
							<div className="testimonial-author">
								<h4>{testimonial.name}</h4>
								<p>{testimonial.role}</p>
							</div>
						</Card>
					))}
				</div>
			</div>
		</section>
	);
};

export default Testimonials;
